export default __webpack_public_path__ + "static/media/00.65c20399.jpg";